import axios from "axios";

// On a custom domain (e.g. csend.net) the same deployment also serves /api, so call it on the page's own origin:
// requests stay same-origin and never depend on the production CORS list.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const onOtherHost = typeof window !== "undefined" && window.location.protocol === "https:" && new URL(ENV_URL).host !== window.location.host;
export const BASE_URL = onOtherHost ? window.location.origin : ENV_URL;
export const API = `${BASE_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const ws = localStorage.getItem("cario_ws");
  if (ws) cfg.headers["X-Workspace-Id"] = ws;
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    const skip = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"].some((p) => url.includes(p));
    if (err.response?.status === 401 && !cfg._retry && !skip) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (refreshErr) {
        // A 401 here just means the visitor is signed out; anything else is worth surfacing in the console.
        if (refreshErr.response?.status !== 401) console.warn("Session refresh failed", refreshErr);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message ? "Network error. Please try again." : "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}
